import React from 'react';

function GuestCountStep({ selectedCenter, guestCount, onGuestCountSelect }) {
  return (
    <div className="step-content">
      <h1 className="step-title">HOW MANY GUESTS?</h1>
      <p className="step-subtitle">{selectedCenter?.name}</p>
      <div className="guest-grid">
        {[1, 2, 3, 4].map(n => (
          <div key={n} className={`big-card ${guestCount === n ? 'selected' : ''}`} onClick={() => onGuestCountSelect(n)}>
            <h3>{n} {n === 1 ? 'Guest' : 'Guests'}</h3>
          </div>
        ))}
        <div className={`big-card guest-grid-full ${guestCount === '5+' ? 'selected' : ''}`} onClick={() => onGuestCountSelect('5+')}>
          <h3>5+ Guests</h3>
          <p style={{fontSize: 12, color: '#999', marginTop: 6}}>Group booking inquiry</p>
        </div>
      </div>
    </div>
  );
}

export default GuestCountStep;
